<div>
  Product/ <strong>Billing</strong> / Review / Payment / Confirmation
</div>
<hr class="hrDiv">
<div class="pageContainer">
<div class="container" *ngIf="!loaded"><mat-spinner></mat-spinner></div>

<div *ngIf="loaded && isSmallView">
    <mat-card class="mat-card lg-flx" *ngIf="membership==='NONMBR'">
        <mat-card-content>
            <h3 class="headerColor">AMA Member?</h3>
            <table class="membTable">
                <tbody>
                <tr>
                <td class="md">Save $80.00 with AMA Member pricing. <span (click)="signup()" class="alink">Sign Up</span> for membership.</td> 
                <td><button mat-fab extended class="btn-cls sm" (click)="signup()">Sign up</button></td>
                </tr>    
                </tbody>
            </table>
        </mat-card-content>      
    </mat-card>   <br>
    <h3 class="headerColor">Billing Address</h3>
    <form [formGroup]="billingAddress"> 
        <mat-card class="mat-card lg-flx">
            <mat-card-content>
                <mat-form-field class="fullLength">
                    <mat-label>First Name</mat-label>
                    <input matInput required formControlName="firstName" name="firstName">
                    <mat-error *ngIf="billingAddress.get('firstName')?.hasError('required')">
                        Required
                    </mat-error>                    
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Last Name</mat-label>
                    <input matInput required formControlName="lastName" name="lastName">
                    <mat-error *ngIf="billingAddress.get('lastName')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="company" name="company">
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Address Line 1</mat-label>
                    <input matInput required formControlName="addressLine1" name="addressLine1">
                    <mat-error *ngIf="billingAddress.get('addressLine1')?.hasError('required')">
                        Required
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Address Line 2</mat-label>
                    <input matInput formControlName="addressLine2" name="addressLine2">
                </mat-form-field>
                <div class="fullLength"> 
                    <div class="half-width-left"> 
                        <mat-form-field>
                            <mat-label>City</mat-label>
                            <input matInput required formControlName="city" name="city">
                            <mat-error *ngIf="billingAddress.get('city')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="half-width-right"> 
                        <mat-form-field>
                            <mat-label>State</mat-label>
                            <mat-select required formControlName="state" name="state">                        
                                <mat-option *ngFor ="let st of abrStates" [value]="st">{{st}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="billingAddress.get('state')?.hasError('required')">
                                Required
                            </mat-error>                 
                        </mat-form-field>
                    </div>
                </div>
                <div class="fullLength">
                    <div class="half-width-left"> 
                        <mat-form-field>
                            <mat-label>Zip Code</mat-label>
                            <input matInput required formControlName="zipCode" name="zipCode">
                            <mat-error *ngIf="billingAddress.get('zipCode')?.hasError('required')">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="half-width-right"> 
                        <mat-form-field>
                            <mat-label style="font-size:smaller">Phone# (10 digits)</mat-label>
                            <input matInput required formControlName="phone" name="phone">
                            <mat-error *ngIf="billingAddress.get('phone')?.hasError('required')">
                                Required
                            </mat-error>
                            <mat-error *ngIf="billingAddress.get('phone')?.hasError('pattern')">
                                Not valid
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>    
                <mat-form-field class="fullLength">
                    <mat-label>Email</mat-label>
                    <input matInput required formControlName="email" name="email">
                    <mat-error *ngIf="billingAddress.get('email')?.hasError('required')">
                        Required
                    </mat-error>
                    <mat-error *ngIf="billingAddress.get('email')?.hasError('email')">
                        Not valid
                    </mat-error>                    
                </mat-form-field>
            </mat-card-content>      
        </mat-card>
    </form><br>
    <mat-card class="mat-card lg-flx">
        <mat-card-content>
            <h3 class="headerColor">Order Summary</h3>
            <div  *ngFor="let product of products">
                <div>{{getProductName(product.itemNumber)}}</div>
                <div>{{getTerm(product.itemNumber)}}</div>
                <div *ngIf="forRenewal">Renewal term beginning : {{getRenewalStartDate(product.itemNumber)}}</div>
                <div><span *ngIf="forRenewal">Renewal </span>Quantity:
                    <span style="scale:0.7;" class="btn-mini-cls round">
                            <button mat-mini-fab class="btn-mini-cls" (click)="minus(product.itemNumber)">-</button>
                            <span class="btn-mini-cls lblSmall pad10">{{getQuantity(product.itemNumber)}}</span>                            
                            <span class="pad10"><button mat-mini-fab class="btn-mini-cls" (click)="plus(product.itemNumber)">+</button></span>
                    </span>                            
                </div>
                <div><span>Unit Price:</span><span class="pad10">{{getUnitPrice(product.itemNumber)}}</span></div>
                <br>    
            </div>                                                
            <div *ngIf="totalDiscount > 0"><span>Discount total:</span><span class="pad10">{{getTotalDiscount()}}</span></div>
            <div><span>Estimated total:</span><span class="pad10">{{getTotalPrice()}}</span></div>
            <div *ngIf="forRenewal">
                <br>
                *If you need to add seats or users to your CURRENT term, please contact our Unified Service Center at: 800-621-8335.
            </div>
        </mat-card-content>      
    </mat-card>
    <br>
    <mat-card class="mat-card lg-flx">
        <mat-card-content>
            <h3 class="headerColor">Have a promo code?</h3>
            <div>
                <mat-form-field class="halfLength">
                    <mat-label class="small">Enter a promo code</mat-label>
                    <input matInput #promoCode [(ngModel)]="promoCodeValue">
                </mat-form-field>                    
                <span class="btn-right-padded-20"><button mat-fab extended class="btn-cls sm" (click)="applyPromoCode(promoCode.value)">Apply</button></span>
            </div>
            <span *ngIf="promoCodes.length > 0">{{promoCodes[0]}} applied
                <button class="btn-right-padded" mat-mini-fab (click)="removePromoCode()" aria-label="remove"><mat-icon>delete</mat-icon></button>
            </span>    
            <span class="error" *ngIf="isError()">{{errorMessage}}</span>
        </mat-card-content>      
    </mat-card><br>
    <mat-card class="mat-card lg-flx">
        <mat-card-content>
            <h3 class="headerColor">Have Tax Exempt status?</h3>
            <div>
                Be sure that this has been approved <i>prior</i> to checking out so that tax will not be applied.  We cannot refund tax if you continue your purchase without pre-approval.<br>
                Need to get approved? <a href="{{preApprovalUrl}}" target="_blank"> Click here</a> 
            </div>
        </mat-card-content>      
    </mat-card> 
    <br>
    <span class="btn-right-padded-20"><button mat-fab extended class="btn-cls md" [routerLink]="['']">Back</button></span>
    <span class="btn-right-padded-20"><button mat-fab extended class="btn-cls md" (click)="openDialog(checkOut)" [disabled]="!billingAddress.valid || totalPrice === 0">Check Out</button></span>                                       
</div>
<table class="full" *ngIf="loaded && !isSmallView">
    <tbody>    
    <tr>
        <td class="col1">            
            <h3 class="headerColor">Billing Address</h3>
            <form [formGroup]="billingAddress">
            <mat-card class="mat-card lg">
            <mat-card-content>
                <mat-form-field class="fullLength">
                    <mat-label>First Name</mat-label>
                    <input matInput required formControlName="firstName" name="firstName">
                    <mat-error *ngIf="billingAddress.get('firstName')?.hasError('required')">
                        First Name is required
                    </mat-error>                    
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Last Name</mat-label>
                    <input matInput required formControlName="lastName" name="lastName">
                    <mat-error *ngIf="billingAddress.get('lastName')?.hasError('required')">
                        Last Name is required
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="company" name="company">
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Address Line 1</mat-label>
                    <input matInput required formControlName="addressLine1" name="addressLine1">
                    <mat-error *ngIf="billingAddress.get('addressLine1')?.hasError('required')">
                        Address Line 1 is required
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Address Line 2</mat-label>
                    <input matInput formControlName="addressLine2" name="addressLine2">
                </mat-form-field>
                <div>
                <mat-form-field>
                    <mat-label>City</mat-label>
                    <input matInput required formControlName="city" name="city">
                    <mat-error *ngIf="billingAddress.get('city')?.hasError('required')">
                        City is required
                    </mat-error>
                </mat-form-field>
                <span class="btn-right-padded-50">
                <mat-form-field>
                    <mat-label>State</mat-label>
                    <mat-select required formControlName="state" name="state">                        
                        <mat-option *ngFor ="let st of abrStates" [value]="st">{{st}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="billingAddress.get('state')?.hasError('required')">
                        State is required
                    </mat-error>                    
                </mat-form-field>
                </span>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Zip Code</mat-label>
                        <input matInput required formControlName="zipCode" name="zipCode">
                        <mat-error *ngIf="billingAddress.get('zipCode')?.hasError('required')">
                            Zip Code is required
                        </mat-error>
                    </mat-form-field>
                    <span class="btn-right-padded-50">
                    <mat-form-field>
                        <mat-label>Phone # (10 digits)</mat-label>
                        <input matInput required maxlength="10" formControlName="phone" name="phone">
                        <mat-error *ngIf="billingAddress.get('phone')?.hasError('required')">
                            Phone number is required
                        </mat-error>
                        <mat-error *ngIf="billingAddress.get('phone')?.hasError('pattern')">
                            Phone number is not valid
                        </mat-error>
                    </mat-form-field>
                    </span>
                </div>    
                <mat-form-field class="fullLength">
                    <mat-label>Email</mat-label>
                    <input matInput required formControlName="email" name="email">
                    <mat-error *ngIf="billingAddress.get('email')?.hasError('required')">
                        Email is required
                    </mat-error>
                    <mat-error *ngIf="billingAddress.get('email')?.hasError('email')">
                        Not a valid email
                    </mat-error>                    
                </mat-form-field>
            </mat-card-content>      
            </mat-card>
            </form>
        </td>
        <td class="col2">
            <mat-card class="mat-card sm">
                <mat-card-content>
                    <h3 class="headerColor">Order Summary</h3>
                    <div  *ngFor="let product of products">
                        <div>{{getProductName(product.itemNumber)}}</div>
                        <div>{{getTerm(product.itemNumber)}}</div>
                        <div *ngIf="forRenewal">Renewal term beginning : {{getRenewalStartDate(product.itemNumber)}}</div>
                        <div><span *ngIf="forRenewal">Renewal </span>Quantity:
                            <span style="scale:0.7;" class="btn-mini-cls round">
                            <button mat-mini-fab class="btn-mini-cls" (click)="minus(product.itemNumber)">-</button>
                            <span class="btn-mini-cls lblSmall pad10">{{getQuantity(product.itemNumber)}}</span>                            
                            <span class="pad10"><button mat-mini-fab class="btn-mini-cls" (click)="plus(product.itemNumber)">+</button></span>
                            </span>                            
                        </div>
                        <div><span>Unit Price:</span><span class="pad10">{{getUnitPrice(product.itemNumber)}}</span></div>
                        <br>    
                    </div>                                                
                    <div *ngIf="totalDiscount > 0"><span>Discount total:</span><span class="pad10">{{getTotalDiscount()}}</span></div>
                    <div><span>Estimated total:</span><span class="pad10">{{getTotalPrice()}}</span></div>
                    <div *ngIf="forRenewal">
                        <br>*If you need to add seats or users to your CURRENT term, please contact our Unified Service Center at: 800-621-8335.
                    </div>
                </mat-card-content>      
            </mat-card>
            <br>
            <mat-card class="mat-card sm">
                <mat-card-content>
                    <h3 class="headerColor">Have a promo code?</h3>
                    <div>
                    <mat-form-field class="halfLength">
                        <mat-label class="small">Enter a promo code</mat-label>
                        <input matInput #promoCode [(ngModel)]="promoCodeValue">
                    </mat-form-field>                    
                    <span class="btn-right-padded-20"><button mat-fab extended class="btn-cls sm" (click)="applyPromoCode(promoCode.value)">Apply</button></span>
                    </div>
                    <span *ngIf="promoCodes.length > 0">{{promoCodes[0]}} applied
                    <button class="btn-right-padded" mat-mini-fab (click)="removePromoCode()" aria-label="remove"><mat-icon>delete</mat-icon></button>
                    </span>    
                    <span class="error" *ngIf="isError()">{{errorMessage}}</span>
                </mat-card-content>      
            </mat-card>
            <hr class="hrDiv">
            <mat-card class="mat-card sm" *ngIf="membership==='NONMBR'">
                <mat-card-content>
                    <h3 class="headerColor">AMA Member?</h3>
                    <table>
                        <tbody>
                        <tr>
                        <td class="md">Save $80.00 with AMA Member pricing. <span (click)="signup()" class="alink">Sign Up</span> for membership.</td> 
                        <td><button mat-fab extended class="btn-cls sm" (click)="signup()">Sign up</button></td>
                        </tr>    
                        </tbody>
                    </table>
                </mat-card-content>      
            </mat-card> <br>
            <mat-card class="mat-card sm">
                <mat-card-content>
                    <h3 class="headerColor">Have Tax Exempt status?</h3>
                    <div>
                        Be sure that this has been approved <i>prior</i> to checking out so that tax will not be applied.  We cannot refund tax if you continue your purchase without pre-approval.<br>
                        Need to get approved? <a href="{{preApprovalUrl}}" target="_blank"> Click here</a> 
                    </div>
                </mat-card-content>      
            </mat-card>   
            <br>
            <span class="btn-right-padded-20"><button mat-fab extended class="btn-cls md" [routerLink]="['']">Back</button></span>
            <span class="btn-right-padded-20"><button mat-fab extended class="btn-cls md" (click)="openDialog(checkOut)" [disabled]="!billingAddress.valid || totalPrice === 0">Check Out</button></span>                                 
        </td>
    </tr>
    </tbody>
  </table>
</div>
  <ng-template #checkOut>
    <div class="lg dlgClass">
    <mat-dialog-content>
        <div>As a AMA member you can save on your purchase today!</div>
    </mat-dialog-content>
    <mat-dialog-actions align="center" class="pad-bottom">
        <div>
            <span class="btn-right-padded-20"><button mat-fab extended matDialogClose class="btn-cls dlg" (click)="gotoOrderReview()">Continue Checkout</button></span>
            <span class="btn-right-padded-20"><button mat-fab extended matDialogClose class="btn-cls dlg" (click)="signup()">Apply for membership</button></span>
        </div>
    </mat-dialog-actions>
    </div>
  </ng-template>